import { CourseEffects } from './course.effects';

export default [CourseEffects];
